
namespace GeniuzPOS.Administration {

    @Serenity.Decorators.registerClass()
    export class PsPosProcessModeDialog extends Serenity.EntityDialog<PsPosProcessModeRow, any> {
        protected getFormKey() { return PsPosProcessModeForm.formKey; }
        protected getIdProperty() { return PsPosProcessModeRow.idProperty; }
        protected getLocalTextPrefix() { return PsPosProcessModeRow.localTextPrefix; }
        protected getNameProperty() { return PsPosProcessModeRow.nameProperty; }
        protected getService() { return PsPosProcessModeService.baseUrl; }
        protected getDeletePermission() { return PsPosProcessModeRow.deletePermission; }
        protected getInsertPermission() { return PsPosProcessModeRow.insertPermission; }
        protected getUpdatePermission() { return PsPosProcessModeRow.updatePermission; }

        protected form = new PsPosProcessModeForm(this.idPrefix);

    }
}